var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav"},[_c('div',[_c('router-link',{staticClass:"top-nav__item",attrs:{"to":"/"}},[_vm._v("首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }